import React, { useState } from 'react';
import styled from 'styled-components';

import Dropdown, { DropdownContainer, DropdownItem } from './Dropdown';
import Icon, { ClickableIcon } from './Icon';
import _theme from '../styles/theme';

const RemoveCourse = styled.div`
  color: ${({ theme }) => theme.color.primary};
`;

type CreditsDropdownProps = {
  credit: { [key: string]: any };
  openRecordModal: (x: any) => void;
  openExtendModal: (x: any) => void;
  openDeleteModal: (x: any) => void;
  // openArchiveModal: (x: any) => void;
};

const CreditsDropdown = ({
  credit,
  openRecordModal,
  openExtendModal,
  openDeleteModal,
  // openArchiveModal,
}: CreditsDropdownProps) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <DropdownContainer key={credit.id}>
      <ClickableIcon
        ml={0.5}
        size={3}
        name="list-ul"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!isOpen);
        }}
        style={{ color: _theme.color.primary }}
      />
      <Dropdown
        outsideClickOnly={false}
        open={isOpen}
        style={{ whiteSpace: 'nowrap', top: '90%', right: '25px' }}
        setOpen={setOpen}
        align="right">
        {credit.status === 'Recorded' && (
          <DropdownItem
            to="#"
            style={{ color: 'green' }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}>
            <Icon
              mr={1}
              style={{ verticalAlign: 'bottom' }}
              name="check-square"
            />{' '}
            Recorded
          </DropdownItem>
        )}
        {/* {credit.status === 'Archived' && (
          <DropdownItem
            to="#"
            style={{ color: 'gray' }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}>
            <Icon mr={1} style={{ verticalAlign: 'bottom' }} name="archive" />{' '}
            Archived
          </DropdownItem>
        )} */}
        {credit.status === 'Extended' && (
          <DropdownItem
            to="#"
            style={{ color: 'blue' }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}>
            <Icon
              mr={1}
              style={{ verticalAlign: 'bottom' }}
              name="external-link-alt"
            />
            Extended
          </DropdownItem>
        )}
        {credit.status !== 'Recorded' &&
          // credit.assessed_skills === credit.total_skills && credit.total_skills > 0 && 
          credit.status === 'Completed' &&
          (
            <>
              <DropdownItem
                to="#"
                style={{ color: 'black' }}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setOpen(false);
                  openRecordModal(credit);
                }}>
                <Icon
                  mr={1}
                  style={{ verticalAlign: 'bottom' }}
                  name="check-square"
                />
                Record
              </DropdownItem>
              {/* <DropdownItem
                to="#"
                style={{ color: 'black' }}
                onClick={(e: any) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setOpen(false);
                  openArchiveModal(credit);
                }}>
                <Icon
                  mr={1}
                  style={{ verticalAlign: 'bottom' }}
                  name="archive"
                />{' '}
                Archive
              </DropdownItem> */}
            </>
          )}
        {/* {credit.status !== 'Recorded' && (
          <DropdownItem
            to="#"
            style={{ color: 'black' }}
            onClick={(e: any) => {
              e.stopPropagation();
              e.preventDefault();
              setOpen(false);
              openExtendModal(credit);
            }}>
            <Icon
              mr={1}
              style={{ verticalAlign: 'bottom' }}
              name="external-link-alt"
            />
            Extend
          </DropdownItem>
        )} */}
        {/* {credit.status !== 'Recorded' &&
          credit.assessed_skills !== credit.total_skills &&
          credit.assessed_skills > 0 && (
            <>
              <DropdownItem
                to="#"
                style={{ color: 'black' }}
                onClick={(e: any) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setOpen(false);
                  openArchiveModal(credit);
                }}>
                <Icon
                  mr={1}
                  style={{ verticalAlign: 'bottom' }}
                  name="archive"
                />{' '}
                Archive
              </DropdownItem>
            </>
          )} */}
        {credit.assessed_skills === 0 && (
          <DropdownItem
            to="#"
            style={{ color: 'black' }}
            onClick={(e: any) => {
              e.stopPropagation();
              e.preventDefault();
              setOpen(false);
              openDeleteModal(credit);
            }}>
            <Icon mr={1} style={{ verticalAlign: 'bottom' }} name="trash" />{' '}
            Delete
          </DropdownItem>
        )}
      </Dropdown>
    </DropdownContainer>
  );
};

export default CreditsDropdown;
